import React from "react";
import { useNavigate } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import { useMediaQuery } from "react-responsive";
import { capitalizeEveryFirstLetter, NumberFormatter } from "../../../../helpers/helpers";

function SubscriptionPlan({ items, recommended }) {
  const navigate = useNavigate();
  const isLaptop = useMediaQuery({ query: "(max-width: 1600px)" });
  return (
    <div
      className={"border-radius-12 pin-top"}
      style={{
        border: "1px solid #6f2da8",
        height: "580px",
        // width: isLaptop ? "350px" : "430px",
      }}
    >
      <div>
        <div style={{ zIndex: "1", padding: isLaptop ? "6px" : "10px" }}>
          <p
            className=" font-18px lenar-gradiant white-text mb-1"
            style={{
              padding: "5px 8px",
              borderRadius: "8px",
            }}
          >
            {capitalizeEveryFirstLetter(items?.name)}
          </p>
          <span className="cercle-purple-text bold font-25px valign-wrapper">
            ₹ {NumberFormatter(items?.price)} /
            <span className="font-20px">
              {items?.numberOfYears}{" "}
              {items?.numberOfYears === 1 ? "year" : "years"}
            </span>
          </span>

          {recommended && <span className="recommended-plan">Recommended</span>}
        </div>
        <hr />
        <div style={{ padding: isLaptop ? "1rem 6px" : "1rem 10px" }}>
          <h2
            className="flex justify-center  font-18px cercle-purple-text "
            style={{ marginTop: "0px" }}
          >
            Features
          </h2>
          {items?.features?.slice(0, 10)?.map((items, index) => (
            <p
              key={items}
              className={`${isLaptop?"font-13px":"font-15px"} valign-wrapper fontstyle NoOfline`}
              style={{ WebkitLineClamp: 1, lineHeight: "25px" }}
            >
              <span className="material-icons-outlined cercle-purple-text font-14px">
                check
              </span>
              <span> {items}</span>
            </p>
          ))}
          {items?.features?.length > 10 && (
            <p
              className=" font-16px valign-wrapper fontstyle NoOfline"
              style={{ WebkitLineClamp: 1, lineHeight: "25px" }}
            >
              <span className="material-icons-outlined cercle-purple-text font-16px">
                check
              </span>
              <span> ..... more</span>
            </p>
          )}
        </div>
      </div>
      <button
        className="cercle-purple-text select-label pointer bold font-16px"
        style={{
          border: "1px solid #6f2da8",
          top: "90%",
          left: "33%",
          borderRadius: "30px",
          padding: "5px 30px ",
        }}
        onClick={() => navigate(`/subscriptionDetails/${items?._id}`)}
      >
        Buy
      </button>
    </div>
  );
}

export default SubscriptionPlan;
